import {
  ReturnSmartText,
  ReturnUnitDescription,
  ReturnUnitQuizzes,
  ReturnUnitSkills,
  SmartText,
  UnitDescription,
  UnitQuizzes,
  UnitSkills,
} from 'Interface/Eva';
import api from 'Service';

const url = '/eva';

const apiEva = api.enhanceEndpoints({}).injectEndpoints({
  endpoints: (construtor) => ({
    getSmartText: construtor.mutation<ReturnSmartText, Partial<SmartText>>({
      query: (data) => ({
        url: `${url}/smart-text`,
        method: 'POST',
        body: data,
      }),
    }),
    getUnitDescription: construtor.mutation<
      ReturnUnitDescription,
      Partial<UnitDescription>
    >({
      query: (data) => ({
        url: `${url}/unit-description`,
        method: 'POST',
        body: data,
      }),
    }),
    getUnitSkills: construtor.mutation<
      ReturnUnitSkills,
      Partial<UnitSkills>
    >({
      query: (data) => ({
        url: `${url}/unit-skills`,
        method: 'POST',
        body: data,
      }),
    }),
    getUnitQuizzes: construtor.mutation<
      ReturnUnitQuizzes,
      Partial<UnitQuizzes>
    >({
      query: (data) => ({
        url: `${url}/unit-quizzes`,
        method: 'POST',
        body: data,
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetSmartTextMutation,
  useGetUnitDescriptionMutation,
  useGetUnitSkillsMutation,
  useGetUnitQuizzesMutation,
} = apiEva;
